import { createApp, markRaw, ref, computed, watch, nextTick } from 'vue'
import InstantSearch from 'vue-instantsearch/vue3/es'
import { history } from 'instantsearch.js/es/lib/routers'
import { simple } from 'instantsearch.js/es/lib/stateMappings'
import WordPressSearchClient from './wordpressSearchClient.js'
import MapComponent from './mapComponent.js'
import HeatMapComponent from './heatMapComponent.js'
import VueSelect from 'vue3-select-component'

function initializeInteractiveTool(instanceId) {
	const container = document.getElementById(instanceId + '-app');
	if (!container) {
		return;
	}
	
	// Get instance-specific data
	const toolData = window.crToolInstances && window.crToolInstances[instanceId] ? window.crToolInstances[instanceId] : {};

	const favoriteStorageKey = 'cr-favorites';
	// Post-type specific filter configurations
	const getFilterConfig = (postType) => {
		const configs = {
			network: {
				hitsPerPage: 6,
				hasSearch: true,
				defaultSort: 'title:asc',
				sortOptions: [
					{ value: 'title:asc', label: 'Title A-Z' },
					{ value: 'title:desc', label: 'Title Z-A' }
				],
				filters: [
					{
						key: 'wbl_service_models',
						type: 'dropdown',
						label: 'WBL Service Models',
						displayMode: 'inline',
						options: [],
						default: ''
					},
					// {
					// 	key: 'wbl_continuum',
					// 	type: 'dropdown',
					// 	label: 'Stage of WBL Continuum',
					// 	displayMode: 'inline',
					// 	options: [],
					// 	default: ''
					// },
					{
						key: 'national_career_clusters_alignment',
						type: 'dropdown',
						label: 'Career Cluster Alignments',
						displayMode: 'inline',
						options: [],
						default: ''
					},
					{
						key: 'states_served',
						type: 'dropdown',
						optionsSort: ['name:asc'],
						label: 'States',
						displayMode: 'inline',
						options: [],
						default: ''
					},
					{
						key: 'modality',
						type: 'dropdown',
						label: 'Modalities',
						displayMode: 'inline',
						options: [],
						default: ''
					},
					{
						key: 'age_groups_served',
						type: 'dropdown',
						label_singular: 'Age Group Served',
						label: 'Age Groups Served',
						displayMode: 'modal',
						optionsOrder: [
							'All Age Groups Served',
							'Grades K–5',
							'Grades 6–8',
							'Grades 9–10',
							'Grades 11–12',
							'Postsecondary'
						],
						options: [],
						default: ''
					},
					{
						key: 'targeted_populations',
						type: 'dropdown',
						label: 'Targeted Populations',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					// {
					// 	key: 'transportation_support',
					// 	type: 'dropdown',
					// 	label: 'Transportation Support',
					// 	displayMode: 'modal',
					// 	options: [],
					// 	default: ''
					// },
					{
						key: 'compensation_type',
						type: 'dropdown',
						label: 'Compensation, Credit & Incentives',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'language_support',
						type: 'dropdown',
						label: 'Language Supports',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'disability_accommodations',
						type: 'dropdown',
						label: 'Disability Accommodations',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'organization_type',
						type: 'dropdown',
						label_singular: 'Organization Type',
						label: 'Organization Types',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'funding_model',
						type: 'dropdown',
						label_singular: 'Funding Model',
						label: 'Funding Models',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'school_based_services',
						type: 'dropdown',
						label: 'School-Based Services',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'stakeholders_served',
						type: 'dropdown',
						label: 'Stakeholders Served',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'geographic_reach',
						type: 'dropdown',
						label_singular: 'Geographic Reach',
						label: 'Geographic Reaches',
						displayMode: 'modal',
						optionsOrder: [
							'Local',
							'Statewide',
							'Regional',
							'National'
						],
						options: [],
						default: ''
					},


					/*
					{
						key: 'locations_served',
						type: 'dropdown',
						label: 'Locations Served',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'years_of_operation',
						type: 'dropdown',
						label: 'Years of Operation',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'volunteers',
						type: 'dropdown',
						label: 'Volunteers',
						displayMode: 'modal',
						options: [],
						default: ''
					},
					{
						key: 'students_served',
						type: 'dropdown',
						label: 'Students Served',
						displayMode: 'modal',
						options: [],
						default: ''
					}
						*/
				]
			},
			library: {
				hitsPerPage: 6,
				hasSearch: true,
				defaultSort: 'title:asc',
				sortOptions: [
					{ value: 'date:desc', label: 'Newest First' },
					{ value: 'date:asc', label: 'Oldest First' },
					{ value: 'title:asc', label: 'Title A-Z' },
					{ value: 'title:desc', label: 'Title Z-A' }
				],
				filters: [
				// {
				// 	key: 'year',
				// 	type: 'range',
				// 	label: 'Year Range',
				// 	displayMode: 'inline',
				// 	min: 1995,
				// 	max: new Date().getFullYear(),
				// 	defaultMin: 1995,
				// 	defaultMax: new Date().getFullYear()
				// },
				{
					key: 'favorites',
					type: 'favorites',
					label: 'Favorites',
					displayMode: 'inline',
					default: false,
					true_values: ['true'],
				},
				{
					key: 'year',
					type: 'toggle',
					label: 'Recent',
					displayMode: 'inline',
					default: false,
					true_values: [new Date().getFullYear(), new Date().getFullYear() - 1],
				},
				{
					key: 'affiliation',
					type: 'toggle',
					label: 'Britebound Resources',
					true_values: ['Primary', 'Partnered'],
					// displayMode: 'modal',
					displayMode: 'inline',
					default: false
				},
				{
					key: 'audience',
					type: 'dropdown',
					label: 'Audience',
					multiple: true,
					displayMode: 'modal',
					options: [],
					default: ''
				},
				{
					key: 'resource_type',
					type: 'dropdown',
					label: 'Resource Type',
					displayMode: 'modal',
					multiple: true,
					options: [],
					default: '',
					optionTooltips: {
						'Papers & Reports': 'written research papers and reports',
						'Articles & Blog Posts': 'articles, blog posts, and other written content',
						'Fact Sheets & Infographics': 'data visualizations, standalone statistics, charts, graphs',
						'Playbooks & Toolkits': 'best practices, guides, tools, actionable strategies',
						'Policy': 'policy briefs, policy language, informational pieces exploring policy issues',
						'Case Studies': 'examples, stories, testimonials',
						'Presentations': 'slideshows, PowerPoints',
						'Learning Instruments': 'lesson plans, curricula, standards for learning, student activities',
						'Audio': 'podcasts, audio-only webinars',
						'Video': 'videos, webinars',
						'Websites': 'website, web-based tools, platforms',
					},
				},
				{
					key: 'theme',
					type: 'dropdown',
					label: 'Theme',
					displayMode: 'modal',
					multiple: true,
					options: [],
					default: ''
				},
				{
					key: 'geographic_location',
					type: 'dropdown',
					label: 'Geographic Location',
					displayMode: 'modal',
					multiple: true,
					options: [],
					default: ''
				},
				{
					key: 'topic',
					type: 'dropdown',
					label: 'Topic',
					displayMode: 'modal',
					multiple: true,
					options: [],
					default: ''
				}
				]
			},
			compass: {
				defaultSort: 'title:asc',
				hasSearch: false,
				hitsPerPage: 100,
				sortOptions: [
					{ value: 'title:asc', label: 'Title A-Z' },
					{ value: 'title:desc', label: 'Title Z-A' }
				],
				filters: [
					{
						key: 'middle_school_bool',
						type: 'toggle',
						label: 'Middle School Career Exploration',
						tooltip: 'Journey of self-discovery that helps students hone in on their strengths and interests, and identify career possibilities.',
						displayMode: 'inline',
						true_values: ['true'],
						default: true
					},
					{
						key: 'high_school_bool',
						type: 'toggle',
						label: 'High School Work-Based Learning (WBL)',
						tooltip: "Hands-on learning opportunities such as internships, apprenticeships, credentialing or credit-bearing opportunities.",
						displayMode: 'inline',
						true_values: ['true'],
						default: true
					},
					{
						key: 'post_secondary_bool',
						type: 'toggle',
						label: 'Postsecondary Education/Career Navigation',
						tooltip: "Counseling and advising youth on transitioning from high school to a broad range of degree and nondegree programs.",
						displayMode: 'inline',
						true_values: ['true'],
						default: true
					}
				]
			},
			compass_asa_grantee: {
				defaultSort: 'title:asc',
				hasSearch: true,
				hitsPerPage: 100,
				sortOptions: [
					{ value: 'title:asc', label: 'Title A-Z' },
					{ value: 'title:desc', label: 'Title Z-A' }
				],
				filters: [
					// {
					// 	key: 'middle_school_bool',
					// 	type: 'toggle',
					// 	label: 'Middle School Career Exploration',
					// 	displayMode: 'inline',
					// 	true_values: ['true'],
					// 	default: true
					// },
					// {
					// 	key: 'high_school_bool',
					// 	type: 'toggle',
					// 	label: 'High School Work-Based Learning (WBL)',
					// 	displayMode: 'inline',
					// 	true_values: ['true'],
					// 	default: true
					// },
					// {
					// 	key: 'post_secondary_bool',
					// 	type: 'toggle',
					// 	label: 'Postsecondary Education/Career Navigation',
					// 	displayMode: 'inline',
					// 	true_values: ['true'],
					// 	default: true
					// },
					// {
					// 	key: 'grant_type',
					// 	type: 'dropdown',
					// 	label: 'Grant Type',
					// 	teleport: '.content',
					// 	displayMode: 'inline',
					// 	multiple: false,
					// 	options: [],
					// 	default: ''
					// }
				]
			}

		};
		
		return configs[postType] || { defaultSort: 'date:desc', hitsPerPage: 6, sortOptions: [], filters: [] };
	};

	const app = createApp({
		template: '#interactive-tool-template-' + instanceId,
		setup() {
			const postTypeData = toolData.postType || 'library'
			const postType = ref(Array.isArray(postTypeData) ? postTypeData : [postTypeData])
			const activePostType = ref(0)

			const indexName = computed(() => postType.value[activePostType.value] || 'library')
			const searchClient = computed(() => markRaw(
				new WordPressSearchClient(toolData.ajaxUrl || '/wp-admin/admin-ajax.php', indexName.value)
			))
			
			const config = computed(() => getFilterConfig(indexName.value))
			const filterConfig = computed(() => markRaw(config.value.filters || []))
			const defaultSort = computed(() => config.value.defaultSort || 'date:desc')
			const sortOptions = computed(() => markRaw(config.value.sortOptions || []))
			const hitsPerPage = computed(() => config.value.hitsPerPage || 6)
			const hasSearch = computed(() => config.value.hasSearch || false)
			const localQuery = ref('')
			const isLoading = ref(false)
			
			// Reactive state for UI
			const showMobileFilters = ref(false)
			const viewMode = ref(indexName.value === 'compass' ? 'map' : 'grid')
			const facetData = ref({})
			const showingFavorites = ref(false)
			const activeState = ref(null)
		
			// Configure routing for URL query string synchronization
			const historyRouter = history({ writeDelay: (indexName.value === 'compass' || indexName.value === 'compass_asa_grantee') ? 40 : 400 });
			const customRouter = {
				read: historyRouter.read.bind(historyRouter),
				createURL: historyRouter.createURL.bind(historyRouter),
				onUpdate: historyRouter.onUpdate.bind(historyRouter),
				write: (routeState) => {
					const url = historyRouter.createURL(routeState);
					window.history.replaceState(routeState, '', url);
				},
				dispose: historyRouter.dispose.bind(historyRouter)
			};
			const routing = markRaw({
				router: customRouter,
				stateMapping: {
					...simple(),
					stateToRoute(uiState) {
						let indexUiState = uiState[indexName.value] || {}
						let routeState;
						
						if(indexName.value === 'compass') {
							routeState = {
								viewing: 0,
								query: indexUiState.query || '',
								viewMode: indexUiState.configure?.viewMode || 'map',
								refinementList: indexUiState.refinementList || {}
							}
						}
						else if(indexName.value === 'compass_asa_grantee') {
							routeState = {
								viewing: 1,
								query: indexUiState.query || '',
								viewMode: indexUiState.configure?.viewMode || 'map',
								refinementList: indexUiState.refinementList || {}
							}
						}
						else {
							routeState = {
								query: indexUiState.query || '',
								sortBy: indexUiState.sortBy || defaultSort.value,
								hitsPerPage: indexUiState.configure?.hitsPerPage || hitsPerPage.value,
								page: indexUiState.page,
								viewMode: indexUiState.configure?.viewMode || (indexName.value === 'compass' || indexName.value === 'compass_asa_grantee' ? 'map' : 'grid'),
								favorites: indexUiState.configure?.favorites || false,
								refinementList: indexUiState.refinementList || {}
							}
						}

						// Track state changes in Google Analytics
						if (typeof gtag !== 'undefined') {
							try{
								gtag('event', 'search_state_change', {
									tool_type: indexName.value,
									query: routeState.query || '',
									sort_by: routeState.sortBy || 'default',
									view_mode: routeState.viewMode,
									has_filters: Object.keys(routeState.refinementList || {}).length > 0,
									favorites_enabled: routeState.favorites || false,
									page: routeState.page || 1,
									context: 'search_interaction'
								});
							}catch(e){
								console.log(e);
							}
						}

						return routeState;
					},
					routeToState(routeState) {
						if(routeState.favorites && routeState.favorites != 'false'){
							showingFavorites.value = true;
						}
						if(routeState.viewMode && (indexName.value !== 'compass' && indexName.value !== 'compass_asa_grantee')){
							viewMode.value = routeState.viewMode;
						} else if(indexName.value === 'compass' || indexName.value === 'compass_asa_grantee') {
							viewMode.value = 'map';

							//set default filters if non have been defined so far
							if(!routeState.refinementList){
								routeState.refinementList = {};
								routeState.refinementList['middle_school_bool'] = ['true'];
								routeState.refinementList['high_school_bool'] = ['true'];
								routeState.refinementList['post_secondary_bool'] = ['true'];
							}
						
						}
						// Update current refinements for ais-configure
						if (routeState.refinementList) {
							// currentRefinements.value = routeState.refinementList;
						}

						localQuery.value = routeState.query || '';

						if(indexName.value === 'compass') {
							
							const event = new CustomEvent('interactiveToolUpdated', {
								detail: {
									indexName: indexName.value,
								}
							});
							document.dispatchEvent(event);

							return {
								[indexName.value]: {
									viewing: 0,
									query: routeState.query || '',
									viewMode: viewMode.value,
									refinementList: routeState.refinementList
								}						
							}
						}
						if(indexName.value === 'compass_asa_grantee') {
							const event = new CustomEvent('interactiveToolUpdated', {
								detail: {
									indexName: indexName.value,
								}
							});
							document.dispatchEvent(event);
							
							return {
								[indexName.value]: {
									viewing: 1,
									query: routeState.query || '',
									viewMode: viewMode.value,
									refinementList: routeState.refinementList
								}						
							}
						}
						return {
							[indexName.value]: {
								query: routeState.query || '',
								sortBy: routeState.sortBy || defaultSort.value,
								hitsPerPage: routeState.hitsPerPage || hitsPerPage.value,
								page: routeState.page,
								viewMode: viewMode.value,
								favorites: showingFavorites.value,
								refinementList: routeState.refinementList
							}
						}
					}
				}
			})
		
			// Get initial state from current route
			const currentRoute = routing.router.read();
			const routeState = routing.stateMapping.routeToState(currentRoute);
			// Dispatch initial interactiveToolUpdated event for default state
			if (indexName.value === 'compass' || indexName.value === 'compass_asa_grantee') {
				const event = new CustomEvent('interactiveToolUpdated', {
					detail: {
						indexName: indexName.value,
					}
				});
				document.dispatchEvent(event);
			}

			// const initialUiState = routeState;
			// const searchFunction = function(helper) {
			// 	return helper.search();
			// 	console.log(helper);
			// 	showingFavorites.value = helper.state.refinementList?.favorites?.includes('true') || false;
			// 	console.log(showingFavorites.value);
			// }

			// const onStateChange = function({ uiState, setUiState }) {
			// 	console.log(uiState);
			// 	setUiState(uiState);
			// }

			// Note: Filter refine functions are now accessed directly via component refs

			return {
				postType,
				activePostType,
				searchClient,
				indexName,
				filterConfig,
				defaultSort,
				sortOptions,
				routing,
				hitsPerPage,
				hasSearch,
				showMobileFilters,
				viewMode,
				facetData,
				showingFavorites,
				activeState,
				isLoading,
				instanceId,
				localQuery
			}
		},
		mounted() {
			// Track start time for session duration measurement
			this.sessionStartTime = Date.now();

			// Track tool visit/initialization in Google Analytics
			if (typeof gtag !== 'undefined') {
				console.log("tool visit GA");
				gtag('event', 'tool_visit', {
					tool_type: this.indexName,
					tool_name: this.indexName === 'library' ? 'Resource Library' : 
							  this.indexName === 'network' ? 'Network Directory' : 
							  this.indexName === 'compass' ? 'Career Compass' : this.indexName,
					context: 'tool_initialization'
				});
			}

			// this.loadFacets();
			this.initFavorites();
			this.setupLoadingIndicator();
			
			// Track initial load state
			this.hasCompletedInitialLoad = false;
			
			// Track when user presses Enter in search
			this.searchByEnter = true;
			
			// Add escape key handler for modal
			this.handleEscapeKey = (event) => {
				if (event.key === 'Escape' && this.showMobileFilters) {
					this.closeModalFilters();
				}
			};
			document.addEventListener('keydown', this.handleEscapeKey);
			
			// Expose method to change activePostType from external JavaScript
			if (!window.crToolInstances) {
				window.crToolInstances = {};
			}
			if (!window.crToolInstances[instanceId]) {
				window.crToolInstances[instanceId] = {};
			}
			
			// Add method to change by post type name
			window.crToolInstances[instanceId].setActivePostTypeByName = (postTypeName) => {
				const index = this.postType.findIndex(type => type === postTypeName);
				if (index !== -1) {
					this.activePostType = index;
				}
			};
			
			// Create global filter manager for external filtering
			if (!window.crFilterManager) {
				window.crFilterManager = {};
			}
			
			window.crFilterManager[instanceId] = {
				applyFilter: (attribute, value) => {
					// console.log(`Applying filter: ${attribute} = ${value} for instance: ${instanceId}`);
					this.applyFilter(attribute, value);
				},
				// Specific convenience methods
				filterByAgeGroup: (value) => {
					this.applyFilter('age_groups_served', value);
				},
				filterByTopic: (value) => {
					this.applyFilter('topic', value);
				},
				filterByResourceType: (value) => {
					this.applyFilter('resource_type', value);
				}
			};
		},
		unmounted() {
			// Track session duration for Library tool (Key KPI)
			if (this.sessionStartTime && this.indexName === 'library' && typeof gtag !== 'undefined') {
				const sessionDuration = Math.round((Date.now() - this.sessionStartTime) / 1000);
				gtag('event', 'session_duration', {
					value: sessionDuration,
					tool_type: this.indexName,
					duration_seconds: sessionDuration,
					duration_minutes: Math.round(sessionDuration / 60),
					context: 'tool_session_tracking'
				});
			}

			// Clean up event listeners
			if (this.handleEscapeKey) {
				document.removeEventListener('keydown', this.handleEscapeKey);
			}
		},
		watch: {
			isLoading(newValue) {
				// Control global loading bar
				const globalLoadingBar = document.getElementById(`global-loading-bar`);
				if (globalLoadingBar) {
					if (newValue) {
						globalLoadingBar.classList.remove('hidden');
					} else {
						globalLoadingBar.classList.add('hidden');
					}
				}
			},
			activeState(newValue) {
				// Scroll to results on mobile when state is selected
				if (this.indexName === 'network' && newValue && window.innerWidth < 768) {
					this.$nextTick(() => {
						const mapViewDetail = document.getElementById('map-view-detail');
						if (mapViewDetail) {
							const elementTop = mapViewDetail.getBoundingClientRect().top + window.pageYOffset;
							const offsetTop = elementTop - 40; // 40px offset from top
							
							window.scrollTo({
								top: offsetTop,
								behavior: 'smooth'
							});
						}
					});
				}
			}
		},
		methods: {
			applyFilter(attribute, value) {
				// Generic method to apply any filter programmatically
				// console.log(`Applying filter: ${attribute} = ${value}`);
				
				// Use the component refs to access refine functions directly
				let refinementComponent = null;
				
				if (attribute === 'age_groups_served') {
					refinementComponent = this.$refs.ageGroupsRefinementList;
				} else if (attribute === 'topic') {
					refinementComponent = this.$refs.topicRefinementList;
				} else if (attribute === 'resource_type') {
					refinementComponent = this.$refs.resourceTypeRefinementList;
				}
				
				if (refinementComponent && refinementComponent.refine) {
					// console.log(`Applying filter via component ref: ${attribute}`);
					refinementComponent.refine(value);
					// console.log(`Applied filter: ${attribute}=${value}`);
					return;
				}
				
				console.warn(`Could not apply filter: ${attribute}=${value} - no refinement component available`);
			},
			createScrollTarget() {
				// Create scroll target element lazily when needed
				const resultsDisplay = document.querySelector('.results-list-display');
				if (resultsDisplay && !this.scrollTarget) {
					const siteHeader = document.querySelector('#site-header .inner-container');
					const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
					const buffer = 40;
					const offsetHeight = headerHeight + buffer;
					
					const scrollTarget = document.createElement('div');
					scrollTarget.className = 'scroll-offset-target';
					scrollTarget.style.cssText = `height: 1px; width: 1px; position:absolute;top:-${offsetHeight}px;left:0;pointer-events: none; visibility: hidden;`;
					
					// Insert scroll target as first child inside the results display
					resultsDisplay.insertBefore(scrollTarget, resultsDisplay.firstChild);
					
					// Store references on Vue instance
					this.resultsDisplay = resultsDisplay;
					this.scrollTarget = scrollTarget;
				}
				return this.scrollTarget;
			},
			scrollToResults() {
				// Create scroll target if it doesn't exist, then scroll
				const scrollTarget = this.createScrollTarget();
				if (scrollTarget) {
					// Scroll to the offset target
					scrollTarget.scrollIntoView({ 
						behavior: 'smooth', 
						block: 'start' 
					});
				}
			},
			onSearchInput(event, refine) {
				// Only refine if 3 or more characters (or empty to clear)
				if (this.localQuery.length >= 3 || this.localQuery.length === 0) {
					refine(this.localQuery);
					
					// Track search in Google Analytics
					if (typeof gtag !== 'undefined' && this.localQuery.length >= 3) {
						gtag('event', 'search', {
							search_term: this.localQuery,
							tool_type: this.indexName,
							tool_name: this.indexName === 'library' ? 'Resource Library' : 
									  this.indexName === 'network' ? 'Network Directory' : 
									  this.indexName === 'compass' ? 'Career Compass' : this.indexName,
							query_length: this.localQuery.length,
							context: 'interactive_search'
						});
					}
				}
			},
			onSearchKeydown(event, refine) {
				if (event.type === 'keydown' && event.key === 'Enter') {
					this.searchByEnter = true;
					this.scrollToResults();
				}else{
					this.searchByEnter = false;
				}
			},
			searchByOrganization(organization) {
				this.localQuery = organization;
				// 	console.log("!!!!", this.instantSearchRef.value);
				// if (this.instantSearchRef.value) {
				// 	this.instantSearchRef.value.mainIndex.helper.setQuery(organization)?.search();
				// }
			},
			setupLoadingIndicator() {
				// Hook into the search client to manage loading state
				const originalSearch = this.searchClient.search.bind(this.searchClient);
				this.searchClient.search = async (requests) => {
					this.isLoading = true;
					
					// Check if this search is triggered by user interaction
					const hasParams = requests.some(request => 
						request.params && (
							(request.params.page !== undefined && request.params.page !== null) ||
							request.params.facetFilters ||
							request.params.numericFilters
						)
					);
					
					const isUserInteraction = this.hasCompletedInitialLoad && hasParams;
					
					try {
						const results = await originalSearch(requests);
						
						// Scroll to results if user pressed Enter OR interacted with filters/pagination
						const shouldScroll = this.searchByEnter && isUserInteraction;
						if (shouldScroll && this.indexName !== 'compass_asa_grantee' && this.indexName !== 'compass') {
							this.scrollToResults();
						}
						
						return results;
					} finally {
						this.isLoading = false;
						// Mark initial load as complete after first search
						if (!this.hasCompletedInitialLoad) {
							this.hasCompletedInitialLoad = true;
						}
					}
				};
			},
			async loadFacets() {
				try {
					this.isLoading = true;
					const response = await this.searchClient.search([{
						query: '',
						params: { page: 0, hitsPerPage: 1 }
					}]);
					
					if (response.results && response.results[0] && response.results[0].facets) {
						this.facetData = response.results[0].facets;
					}
				} catch (error) {
					console.error('Error loading facets:', error);
				} finally {
					this.isLoading = false;
				}
			},
			openMobileFilters() {
				this.showMobileFilters = true;
			},
			closeModalFilters() {
				this.showMobileFilters = false;
			},
			closeModalFiltersClick(event) {
				if (event.target.classList.contains('fixed')) {
					this.closeModalFilters();
				}

				// Check if the click is related to vue-select functionality
			},
			shareItem(item) {
				if (navigator.share) {
					navigator.share({
						title: item.title,
						url: item.url
					});
				} else {
					navigator.clipboard.writeText(item.url);
					alert('Link copied to clipboard!');
				}
			},
			toggleFavoritesFilter(isEnabled) {
				this.showingFavorites = isEnabled;
				
				// Track favorites filter toggle in Google Analytics
				if (typeof gtag !== 'undefined') {
					gtag('event', 'favorites_filter_toggle', {
						tool_type: this.indexName,
						filter_action: isEnabled ? 'enable' : 'disable',
						is_enabled: isEnabled,
						context: 'favorites_filter_interaction'
					});
				}
			},
			handleSortChange(refineFunction, value, items) {
				// Apply the sort refinement
				refineFunction(value);
				
				// Find the selected item to get the label
				const selectedItem = items.find(item => item.value === value);
				const sortLabel = selectedItem ? selectedItem.label : value;
				
				// Track sort change in Google Analytics
				if (typeof gtag !== 'undefined') {
					gtag('event', 'sort_change', {
						tool_type: this.indexName,
						sort_option: value,
						sort_label: sortLabel,
						context: 'search_interaction'
					});
				}
			},
			viewCitations(item) {
				console.log('Viewing citations for:', item);
			},
			viewItem(item) {
				// Track specific interactions based on tool type
				if (typeof gtag !== 'undefined') {
					if (this.indexName === 'library' && item.resource_link) {
						// Track Library downloads/resource access - Key KPI
						gtag('event', 'download', {
							file_name: item.title,
							tool_type: 'library',
							resource_id: item.id || item.post_id,
							resource_title: item.title,
							resource_format: item.resource_format || 'unknown',
							resource_url: item.resource_link,
							context: 'library_resource_access'
						});
					} else if (this.indexName === 'network') {
						// Track Network card clicks - Key KPI
						gtag('event', 'select_content', {
							content_type: 'network_organization',
							tool_type: 'network',
							organization_id: item.id || item.post_id,
							organization_name: item.title || item.name,
							organization_type: item.organization_type || 'unknown',
							states_served: item.states_served || 'unknown',
							context: 'network_card_interaction'
						});
					} else {
						// General item view tracking for other tools
						gtag('event', 'view_item', {
							tool_type: this.indexName,
							item_id: item.id || item.post_id,
							item_title: item.title || item.name,
							item_type: this.indexName,
							context: 'generic_item_view'
						});
					}
				}
				
				if (this.indexName === 'library' && item.resource_link) {
					window.open(item.resource_link, '_blank');
				}
				if (this.indexName === 'network'){
					window.location = item.url;
				}
			},
			initFavorites() {
				//favorites changed. trigger favorite search if that is the active filter
				window.addEventListener('localStorageChange', (e) => {
					if (e.detail?.storageKey === favoriteStorageKey && window.location.search.indexOf('topic%5D=Favorites') !== -1) {
						// this.doFavoriteSearch();
					}
				});

			},
			populateFilterOptions(filters) {
				return filters.map(filter => {
					if (filter.type === 'dropdown' && this.facetData[filter.key]) {
						const facetOptions = Object.keys(this.facetData[filter.key]).map(value => ({
							value: value,
							label: value,
							count: this.facetData[filter.key][value]
						}));
						
						return {
							...filter,
							options: facetOptions
						};
					} else if (filter.type === 'range' && this.facetData[filter.key]) {
						return {
							...filter,
							min: this.facetData[filter.key].min,
							max: this.facetData[filter.key].max
						};
					}
					return filter;
				});
			},
			toggleFilterValues(filter, items, refine, checked) {
				if (!filter.true_values || !Array.isArray(filter.true_values)) {
					return;
				}

				// Track filter usage in Google Analytics
				if (typeof gtag !== 'undefined') {
					gtag('event', 'filter_use', {
						tool_type: this.indexName,
						filter_name: filter.key,
						filter_action: checked ? 'apply' : 'remove',
						filter_value: filter.true_values.join(','),
						context: 'filter_interaction'
					});
				}
				
				if (checked) {
					// When toggling ON, refine all true_values
					filter.true_values.forEach(value => {
						const item = items.find(item => item.value == value);
						if (item) {
							refine(value);
						}
					});
				} else {
					// When toggling OFF, unrefine all true_values
					filter.true_values.forEach(value => {
						const item = items.find(item => item.value == value);
						if (item && item.isRefined) {
							refine(value);
						}
					});
				}
			},
			getVisiblePages(pages, currentPage) {
				const totalPages = pages.length;
				const maxVisible = 5;
				
				if (totalPages <= maxVisible) {
					return pages;
				}
				
				let start = Math.max(0, currentPage - Math.floor(maxVisible / 2));
				let end = Math.min(totalPages, start + maxVisible);
				
				// Adjust start if we're near the end
				if (end - start < maxVisible) {
					start = Math.max(0, end - maxVisible);
				}
				
				return pages.slice(start, end);
			},
		},
		computed: {
			inlineFilters() {
				return this.populateFilterOptions(
					(this.filterConfig || []).filter(filter => filter.displayMode === 'inline')
				);
			},
			modalFilters() {
				return this.populateFilterOptions(
					(this.filterConfig || []).filter(filter => filter.displayMode === 'modal')
				);
			},
			favoritesFilter() {
				if(this.showingFavorites){
					const favorites = JSON.parse(localStorage.getItem(favoriteStorageKey)) || [];
					
					// Filter favorites for current post type and extract IDs
					const relevantIds = favorites
						.filter(fav => fav.startsWith(`${this.indexName}-`))
						.map(fav => fav.replace(`${this.indexName}-`, ''));
					
					console.log('Filtered favorite IDs:', relevantIds);
					if(relevantIds.length > 0){
						return relevantIds.join(',');
					}else{
						return '-1';
					}
				}
				return '';
			}
		}
	});

	// Register the US Map component
	app.component('us-map', MapComponent(instanceId));
	
	// Register the Heatmap component
	app.component('heat-map', HeatMapComponent(instanceId));

	// Register the filter component
	app.component('filter-component', {
		template: '#filter-component-template-' + instanceId,
		props: ['filter', 'displayMode', 'showingFavorites'],
		emits: ['toggle-filter', 'toggle-favorites']
	});

	// Register post-type specific card components
	app.component('card-library', {
		template: '#card-library-template-' + instanceId,
		props: ['item', 'viewMode'],
		emits: ['share-item', 'toggle-favorite', 'view-citations', 'view-item', 'filter-topic', 'filter-resource_type'],
		data() {
			return {
				showCitations: false
			}
		},
		methods: {
			toggleCitations() {
				console.log('Toggling citations for:', this.item);
				// Toggle the showCitations data property
				this.showCitations = !this.showCitations;
				
				// Toggle the class on the card container
				const cardContainer = this.$refs.cardContainer;
				if (cardContainer) {
					cardContainer.classList.toggle('show-citations', this.showCitations);
				}
				
				// Still emit to parent if needed for analytics/tracking
				this.$emit('view-citations', this.item);
			}
		}
	});
	app.component('card-network', {
		template: '#card-network-template-' + instanceId,
		props: ['item', 'viewMode'],
		emits: ['share-item', 'toggle-favorite', 'view-citations', 'view-item', 'filter-age-group'],
		data() {
			return {
				isExpanded: false
			}
		},
		methods: {
			filterAgeGroup(ageGroup ) {
				// if ageGroup string contains "Elementary" replace with "elem."
				if (ageGroup.toLowerCase().includes('elementary')) {
					ageGroup = ageGroup.replace('Elementary', 'elem.');
				}

				// if ageGroup string contains "School" replace with "sch."
				if (ageGroup.toLowerCase().includes('school')) {
					ageGroup = ageGroup.replace('school', 'sch.');
				}

				return ageGroup;
			},
			checkStatesServed(states, returnAbbvs = false) {
				if (!Array.isArray(states) || !states.length) return '';
                
                const stateAbbreviations = {
                    'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR',
                    'california': 'CA', 'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE',
                    'florida': 'FL', 'georgia': 'GA', 'hawaii': 'HI', 'idaho': 'ID',
                    'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA', 'kansas': 'KS',
                    'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
                    'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS',
                    'missouri': 'MO', 'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV',
                    'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY',
                    'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH', 'oklahoma': 'OK',
                    'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
                    'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT',
                    'vermont': 'VT', 'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV',
                    'wisconsin': 'WI', 'wyoming': 'WY', 'district of columbia': 'DC'
                };

                // If only one state, return it as is
                if (states.length === 1) {
                    return states[0];
                }

                // Convert array of state names to abbreviations
                const returnStateAbbv = states.map(state => {
                    const stateLower = state.toLowerCase().trim();
                    return stateAbbreviations[stateLower] || state;
                }).join(', ');

				if (returnAbbvs) {
					return returnStateAbbv;
				}
				
				return (returnStateAbbv.length > 1) ? 'Multiple States' : returnStateAbbv;
            }
		}
	});

	// Register vue3-select-component
	app.component('VueSelect', VueSelect);

	app.config.globalProperties.sortDropdownItems = function(items, optionsOrder) {
		if (!optionsOrder || !Array.isArray(optionsOrder)) {
			return items;
		}
		return [...items].sort((a, b) => {
			const indexA = optionsOrder.indexOf(a.label);
			const indexB = optionsOrder.indexOf(b.label);
			if (indexA !== -1 && indexB !== -1) return indexA - indexB;
			if (indexA !== -1) return -1;
			if (indexB !== -1) return 1;
			return 0;
		});
	};

	app.use(InstantSearch);
	app.mount('#' + instanceId + '-app');
}

document.addEventListener('DOMContentLoaded', function() {
	// Initialize all interactive tool instances found on the page
	if (window.crToolInstances) {
		Object.keys(window.crToolInstances).forEach(instanceId => {
			initializeInteractiveTool(instanceId);
		});
	}
});
